/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreatePolicyResponse
 */
export interface CreatePolicyResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreatePolicyResponse
     */
    id: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the CreatePolicyResponse interface.
 */
export function instanceOfCreatePolicyResponse(value: object): value is CreatePolicyResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreatePolicyResponseFromJSON(json: any): CreatePolicyResponse {
    return CreatePolicyResponseFromJSONTyped(json, false);
}

export function CreatePolicyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePolicyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
    };
}

export function CreatePolicyResponseToJSON(json: any): CreatePolicyResponse {
    return CreatePolicyResponseToJSONTyped(json, false);
}

export function CreatePolicyResponseToJSONTyped(value?: CreatePolicyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
    };
}

